import { useAdminPersonsController_findOne } from '@api-client/generated/AdminPersonsController/findOne';

export const useDriveLink = (companyId: string) => {
  const { data: person } = useAdminPersonsController_findOne({
    params: {
      companyId: companyId,
      id: companyId,
    },
    config: {
      enabled: !!companyId,
    },
  });

  if (person?.kycData?.address?.countryCode === 'FR') {
    return `https://drive.google.com/drive/u/2/folders/14qKKzHAfuyiRWz1Wr70K1CT_HfCOvMzI`;
  }

  return `https://drive.google.com/drive/u/2/folders/1ThGFyr-CPhhyC7FQaj8TdahsrXFnqs5C`;
};
